module.exports = __webpack_public_path__ + "static/media/bg-music.3f0dbbfa.mp3";